<template>
  <main class="report">
    <div class="report-row top-row">
      <nameplate :report="report"></nameplate>
      <div class="plate donuts">
        <header class="plate-header" style="height:10%;">
        </header>
        <div class="donut-inner">
          <donut v-for="(donut, index) in donuts" :percentages="getAlertPercentages(index)"></donut>
        </div>
      </div>
    </div>
    <div class="report-row mid-row">
      <div class="plate children" v-if="$store.getters.getReportEntity() == 'building'">
        <header class="plate-header">
          <div class="plate-header-img">
            <img src="https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/company.png" alt="">
          </div>
          <h2>Building Reports</h2>
        </header>
        <div class="children-inner">
          <child v-for="(child, childIndex) in report.entity.buildings" :reports="report.reports.filter(r => r.reportPK == child)"></child>
        </div>
      </div>
      <crp :avg="crpSet()"></crp>
    </div>
    <!-- <div class="report-row end-row">

    </div> -->
  </main>
</template>

<script>

// TODO: average building AVERAGES

import Nameplate from './Nameplate';
import Donut from './Donut';
import Child from './Child';
import CRP from './CRP'

export default {

  data(){
    return {
      donuts: ['run', 'ttp', 'hhm', 'iaq', 'co2', 'voc']
    }
  },
  computed: {
    report: function(){
      return this.$store.getters.getReport();
    },
    entity: function(){
      return this.$store.getters.getReportEntity();
    }
  },
  components: {
    nameplate: Nameplate,
    donut: Donut,
    child: Child,
    crp: CRP
  },
  methods: {
    getAlertPercentages(index){
      const self = this;
      if (this.$store.getters.getReportEntity() == 'building') {
        const percs = [
          {
            on: 38,
            off: 62,
            img: 'on'
          }
        ].concat(this.donuts.reduce((averages, rdg, rdgIndex) => {
          if (rdgIndex !== 0) {
            let totalTotal = self.report.reports.reduce((total, day, dayIndex, dayArr) => {
              ['ttp']
              const tiers = ['good', 'bad', 'crit']
              tiers.forEach(tier => {
                total[tier] += day.alertRanges[rdg][tier];
              })
              if (dayIndex == dayArr.length - 1) {
                tiers.forEach(tier => {
                  total[tier] = Math.round(total[tier]/dayArr.length);
                  // if (Object.keys(shouldEqual100).reduce((a, i) => a + i, 0) != 100) {
                  //   // TODO: fix this crap
                  //   const greatest = Math.max.apply(Math, shouldEqual100[i].map())
                  //   const diff =
                  // }
                  // return shouldEqual100
                });
                total.img =
                  ['', 'temp', 'hum', 'iaq', 'co2', 'nuevoVOC'][rdgIndex];
              }
              return total;
            }, {good: 0, bad: 0, crit: 0});
            averages.push(totalTotal)
          }
          return averages;
        }, []));
        return percs[index];
      }
    },
    crpSet(){
      if (this.entity == 'building') {
        return this.report.reports.reduce((bAvgs, b, bIndex, bArr) => {
          this.donuts.slice(1, this.donuts.length).forEach(d => {
            bAvgs[d] = !bAvgs[d] ? b.avg[d] : bAvgs[d] + b.avg[d];
          });
          if (bIndex == bArr.length - 1) {
            Object.keys(bAvgs).forEach(bProp => {
              const avged = bAvgs[bProp]/bArr.length
              bAvgs[bProp] = bProp == 'voc' ? parseFloat((avged).toFixed(3)) : Math.round(avged);
            });
          }
          return bAvgs;
        }, {});
      }
    }
  },
  async mounted(){
    await this.$store.dispatch('getOrgReports');
    console.log({ENTITY: this.entity});
  }

}

</script>

<style>

.report {
  width: 98vw;
  height: calc(100% - 80px);
  margin-top: 80px;
  max-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  overflow-x: hidden;
  margin-top: 40px;
  margin-bottom: 0px;
  padding-bottom: 0px;
}

.report-row {
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.top-row {
  height: 25%;
  min-height: 250px;
}

.plate {
  height: 100%;
  background-color: #333237;
  border-radius: 4px;
  border: 1px solid rgb(0, 153, 191);
  overflow: hidden;
}

.plate-header {
  height: 100px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #325468;
  border-top: 1px solid rgb(0, 153, 191);
  border-bottom: 10px solid rgb(0, 153, 191);
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  overflow: hidden;
}

.plate-header-img {
  height: 100%;
  width: 80px;
  background-color: rgb(0, 153, 191);
  display: flex;
  justify-content: center;
  align-items: center;
  border-top-left-radius: 4px;
}

.plate-header-img img {
  height: 60%;
}

.plate-header h2 {
  width: 30%;
  text-align: center;
}

.plate-body {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  height: 69%;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  overflow: hidden;
  padding-top: 1%;
}

.plate-body-sec {
  width: 48.75%;
  height: 30%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #325468;
  margin: 2px;
  border-radius: 3px;
}

.plate-body-sec h5 {
  text-align: left;
  font-size: .7em;
}

.donuts {
  width: 72%;
}

.donut-inner {
  width: calc(100% - 4px);
  height: 86%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}

.mid-row {
  height: 65%;
  margin-top: 1%;
  margin-bottom: 1%;
}

.end-row {
  height: 7.5%;
}

.children {
  width: 68.5%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.children-inner {
  height: 90%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  overflow-x: scroll;
  overflow-y: hidden;
  padding-left: 20px;
  padding-right: 20px;
}

</style>



// WEBPACK FOOTER //
// src/components/report/Report.vue